// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__s_O2d","label":"Labeled_label__aGnbo","divider":"Labeled_divider__22-6w"};